// @ts-check
/**
 * @file sentry.js
 * @location src/integrations/sentry.js
 * @role Sentry 에러 트래커 진입점.
 *
 *  initSentry()         — main.jsx 부팅 시 1회 호출. DSN 미설정 시 noop.
 *  captureError(e, ctx) — 명시적 캡처 (ErrorBoundary·wrappedAct·outbox 등에서).
 *
 *  DEV/test 환경: VITE_SENTRY_DSN 미설정 → init 안 함 → noop.
 *  PROD: DSN 있으면 init + browserTracing 통합.
 *
 *  Source map 은 @sentry/vite-plugin 이 빌드 시 업로드 (vite.config.js).
 */
import * as Sentry from '@sentry/react';

const DSN = import.meta.env.VITE_SENTRY_DSN;

/** main.jsx 가 ErrorBoundary 마운트 전 1회 호출. */
export function initSentry() {
  if (!DSN) return;   // 환경 미설정 → noop
  Sentry.init({
    dsn: DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,   // 10% 트레이스 샘플링 — 베타 단계 충분
    environment: import.meta.env.MODE,
  });
}

/**
 * @param {unknown} error
 * @param {{ extra?: Record<string, unknown>, tags?: Record<string, string> }} [ctx]
 */
export function captureError(error, ctx = {}) {
  Sentry.captureException(error, ctx);
}
